export default __webpack_public_path__ + "0be1206714b844c7c8812c5963748e37.png";